import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import Paper from '@mui/material/Paper'
import { Key, ReactElement, useEffect, useState } from 'react'
import DevelopusTreeTableHead, {
  DevelopusTreeTableHeadType,
} from './DevelopusTreeTableHead'
import DevelopusTreeTableFoot from './DevelopusTreeTableFoot'
import DevelopusTreeTableBody, {
  DevelopusTreeTableBodyType,
} from './DevelopusTreeTableBody'
import { UUID } from 'crypto'

export type DevelopusTreeTableType = {
  key: Key
  head: DevelopusTreeTableHeadType
  body: DevelopusTreeTableBodyType
}

interface Props {
  table: DevelopusTreeTableType
  collapsed: boolean
  refreshPage: boolean
  handleEdit: (id?: UUID) => void
  handleRemove: (id?: UUID) => void
}

const DevelopusTreeTable = (props: Props): ReactElement => {
  const { head, body } = props.table

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  useEffect(() => {
    if (props.refreshPage) {
      setTimeout(() => {
        setPage(0)
      }, 500)
    }
  }, [props.refreshPage])

  useEffect(() => {
    setPage(0)
  }, [props.collapsed])

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
        <DevelopusTreeTableHead head={head} />
        <DevelopusTreeTableBody
          body={body}
          page={page}
          rowsPerPage={rowsPerPage}
          handleEdit={props.handleEdit}
          handleRemove={props.handleRemove}
        />
        <DevelopusTreeTableFoot
          rowsLength={body.items.length}
          page={page}
          rowsPerPage={rowsPerPage}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
        />
      </Table>
    </TableContainer>
  )
}

export default DevelopusTreeTable
